module.exports = __webpack_public_path__ + "static/media/eye-open.74509491.svg";